import { toString } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { defaultOf } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";

function removeValue(key) {
    localStorage.removeItem(key);
}

function setValue(key, value) {
    localStorage.setItem(key, value);
}

function getValue(key) {
    return localStorage.getItem(key);
}

export function clearAll() {
    localStorage.clear();
}

export function IsQuickFinderSortierungAufsteigend_set(value) {
    setValue("quickfindersortierung", toString(value));
}

export function IsQuickFinderSortierungAufsteigend_get() {
    const matchValue = getValue("quickfindersortierung");
    if (matchValue === defaultOf()) {
        return false;
    }
    else if (matchValue.toLocaleUpperCase() === "TRUE") {
        return true;
    }
    else {
        return false;
    }
}

//# sourceMappingURL=Storage.fs.js.map
